module.exports = "/_next/static/images/RV-220e90af3fa14cfe0324d2479428c531.svg";